import React, { useState, FormEvent, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as ClubticketsIcon } from '../Clubtickets.svg';
import { AuthContext } from '../contexts/AuthContext';

interface LoginProps 
{
  onLoginSuccess: () => void;
}

const Login: React.FC<LoginProps> = ({ onLoginSuccess }) => 
{
  const [usernameInput, setUsernameInput] = useState<string>('');
  const [passwordInput, setPasswordInput] = useState<string>('');
  const [error, setError] = useState<string>('');
  const { setToken, setUsername } = useContext(AuthContext);
  
  const navigate = useNavigate(); // Para redirección

  const handleSubmit = async (event: FormEvent) => 
  {
    event.preventDefault();

    try 
    {
      // Construir los datos en formato URL-encoded
      const api_url = process.env.REACT_APP_API_BASE_URL || '';
      const response = await fetch(`${api_url}web/login_check`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          username: usernameInput,
          password: passwordInput
        })
      });

      // Verifica si la respuesta es válida
      if (response.ok) 
      {
        const data = await response.json();    
        if (data.token) 
        {
          // Guardamos el token y el username en el contexto
          setToken(data.token);
          setUsername(usernameInput);

          onLoginSuccess();

          navigate('/main'); // Redirige a la página principal después del login exitoso
        } 
        else 
        {
          setError('Error de autenticación');
        }
      } 
      else 
      {
        const errorData = await response.json();
        setError(errorData.error || errorData.message || 'Error de autenticación');
      }
    } 
    catch (error) 
    {
      console.log(error);
      const error_msg = error instanceof Error ? error.message : 'Error desconocido';
      setError(error_msg);
    }
  };

  return (
    <div className="login-container">      
      <ClubticketsIcon className="login-logo" /> {/* Logo encima del formulario */}
      <div className="version-info">
              {process.env.REACT_APP_VERSION || ''}
            </div>
      <form className="login-form" onSubmit={handleSubmit}>
        <h2>
          <span>LOGIN</span>
        </h2>
        <div className="form-group">
          <i className="fas fa-user input-icon"></i>
          <input
            id="username"
            type="text"
            placeholder='Usuario'
            value={usernameInput}
            onChange={(e) => setUsernameInput(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <i className="fas fa-lock input-icon"></i>
          <input
            id="password"
            type="password"
            placeholder='Password'
            value={passwordInput}
            onChange={(e) => setPasswordInput(e.target.value)}
            required
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="login-button">Entrar</button>
      </form>
    </div>
  );
};

export default Login;
